import { connect } from 'react-redux'
import { IGlobalState } from '../../../../Root/store/appReducer'
import ChatList, { IChatListDispatchProps, IChatListOwnProps } from './ChatList'
import {
  userDtoSelector,
  userCompaniesSelector,
  companyDivisionsSelector,
} from '../../../Settings/store/SettingsSelectors'
import { getCompanyDivisions } from '../../../Settings/store/SettingsActions'
import { getUserGoals, getGoalsDtoLoading } from '../../../Activity/store/ActivitySelectors'
import { getCurrentCompanyGoal } from '../../../Activity/store/ActivityActions'
import { getChatChannelMeta, getChatListFilter } from '../../store/ChatSelectors'
import { setChatChannelMeta, setChatListFilter } from '../../store/ChatActions'

const mapStateToProps = (state: IGlobalState, ownProps: IChatListOwnProps) => ({
  ...ownProps,
  userDto: userDtoSelector(state),
  userGoals: getUserGoals(state),
  goalsLoading: getGoalsDtoLoading(state),
  userCompanies: userCompaniesSelector(state),
  divisions: companyDivisionsSelector(state),
  chatListFilter: getChatListFilter(state),
  channelMeta: getChatChannelMeta(state),
})

const mapDispatchToProps: IChatListDispatchProps = {
  getCurrentCompanyGoal,
  getCompanyDivisions,
  setChatListFilter,
  setChatChannelMeta,
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatList)
